module.exports = __webpack_public_path__ + "static/media/218.219642b3.wav";